<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <PrimeMessage
    v-if="checked && !loading && !health.ok"
    severity="error"
    :closable="false"
  >
    <div>
      <div class="font-semibold mb-2">
        <i class="ri-error-warning-line mr-2" aria-hidden="true" />
        {{ $t("configHealth.error.title") }}
      </div>
      <p class="m-0 line-height-3">
        {{ $t("configHealth.error.description", { instance: instanceName }) }}
      </p>
      <code class="block mt-2 text-sm"> pristy-config/{{ instanceName }} </code>
      <p class="mt-2 mb-0 text-sm">
        {{ $t("configHealth.error.action") }}
      </p>
    </div>
  </PrimeMessage>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Message from "primevue/message";
import ProgressSpinner from "primevue/progressspinner";
import configHealthService from "@/services/ConfigHealthService.js";
import { useConfigStore } from "@/stores/config.js";

const PrimeMessage = Message;
const PrimeProgressSpinner = ProgressSpinner;

const configStore = useConfigStore();
const instanceName = configStore.INSTANCE_NAME;

const health = ref({ ok: true, detail: "" });
const loading = ref(false);
const checked = ref(false);

onMounted(async () => {
  loading.value = true;
  try {
    health.value = await configHealthService.check();
  } finally {
    loading.value = false;
    checked.value = true;
  }
});

defineExpose({ health, checked });
</script>
